angular.module('callX').service('RealTimeService', ['$http',
  function ($http){

    var getRealTimeData = function(userId, timeStamp, callbacks){
      var query = "?last="+ encodeURIComponent(timeStamp);
      query = query + ("&id="+userId);
      $http.showLoading = false;
      $http.get("/japi/real-time/publisher-realtime"+query)
          .success(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          })
          .error(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          });
    };

    return {
      getRealTimeData: function (userId, timeStamp, callbacks) {
        getRealTimeData(userId, timeStamp, callbacks);
      }
    };
  }]);